<template>
  <div id="app">
    <router-view />
    <footer v-if="showGlobalFooter" class="global-footer">
      <div class="footer-content">
        <span class="footer-text">憨猴科技 提供技术支持</span>
      </div>
    </footer>
    <!-- 返回顶部按钮 -->
    <button v-show="showBackToTop" class="back-to-top" @click="scrollToTop" aria-label="返回顶部">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <!-- 商务合作弹窗 -->
    <el-dialog v-model="showBusinessDialog" :title="false" :width="isMobile ? '90%' : '520px'"
      :close-on-click-modal="true" class="business-dialog" :show-close="true" :modal="true"
      :modal-class="'business-dialog-overlay'">
      <template #header>
        <div class="business-dialog-header">
          <div class="business-dialog-header-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h3 class="business-dialog-header-title">关于我们</h3>
        </div>
      </template>
      <div class="business-dialog-content">
        <!-- <p class="business-dialog-desc">欢迎商务合作咨询，期待与您携手共创价值</p> -->

        <!-- 核心功能展示区域 -->
        <div class="business-feature-section">
          <div class="business-feature-box">
            <div class="business-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="business-feature-content">
              <h4 class="business-feature-title">一站式内容生成</h4>
              <p class="business-feature-desc">基于AI技术，一键生成图片、视频、文案等全类型素材，高效赋能内容创作全流程</p>
            </div>
          </div>
        </div>

        <!-- 联系方式区域 -->
        <div class="contact-section">
          <div class="contact-section-title">联系方式</div>
          <div class="contact-info-list">
            <div class="contact-info-item">
              <div class="contact-icon contact-icon--wechat">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.5 12C8.5 12.8284 9.17157 13.5 10 13.5C10.8284 13.5 11.5 12.8284 11.5 12C11.5 11.1716 10.8284 10.5 10 10.5C9.17157 10.5 8.5 11.1716 8.5 12Z"
                    fill="currentColor" />
                  <path
                    d="M15.5 12C15.5 12.8284 16.1716 13.5 17 13.5C17.8284 13.5 18.5 12.8284 18.5 12C18.5 11.1716 17.8284 10.5 17 10.5C16.1716 10.5 15.5 11.1716 15.5 12Z"
                    fill="currentColor" />
                  <path
                    d="M12 2C6.47715 2 2 6.14903 2 11.3C2 14.05 3.23447 16.55 5.26154 18.3L4.5 21.5L8.07692 19.85C9.19231 20.05 10.3462 20.15 11.5 20.15C17.5228 20.15 22 16.001 22 11.3C22 6.59897 17.5228 2 12 2Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="contact-info">
                <span class="contact-label">微信</span>
                <span class="contact-value">R-9999120</span>
              </div>
            </div>
            <div class="contact-info-item">
              <div class="contact-icon contact-icon--phone">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="contact-info">
                <span class="contact-label">电话</span>
                <a href="tel:15201532349" class="contact-value contact-link">15201532349</a>
              </div>
            </div>
            <div class="contact-info-item">
              <div class="contact-icon contact-icon--email">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="contact-info">
                <span class="contact-label">邮箱</span>
                <a href="mailto:victory_pang@sina.com" class="contact-value contact-link">pangjianqing@hanhou.cn</a>
              </div>
            </div>
          </div>
        </div>

        <div class="business-dialog-footer">
          <span class="business-footer-text">憨猴科技集团有限公司 提供技术支持</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, provide, computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  // eslint-disable-next-line space-before-function-paren
  setup() {
    const route = useRoute()
    const showBackToTop = ref(false)
    const showBusinessDialog = ref(false)
    const isMobile = computed(() => {
      if (typeof window !== 'undefined') {
        return window.innerWidth <= 768
      }
      return false
    })

    // 在登录和注册页面隐藏全局footer
    const showGlobalFooter = computed(() => {
      return route.name !== 'Login' && route.name !== 'Register'
    })

    const handleScroll = () => {
      // 当滚动超过 300px 时显示按钮
      showBackToTop.value = window.scrollY > 300 || document.documentElement.scrollTop > 300
    }

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const openBusinessDialog = () => {
      showBusinessDialog.value = true
    }

    const closeBusinessDialog = () => {
      showBusinessDialog.value = false
    }

    // 提供给子组件使用
    provide('openBusinessDialog', openBusinessDialog)

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      showBackToTop,
      scrollToTop,
      showBusinessDialog,
      openBusinessDialog,
      closeBusinessDialog,
      isMobile,
      showGlobalFooter
    }
  }
}
</script>
<style>
/* 全局样式：覆盖 Element Plus 弹窗的默认白色背景 */
.el-dialog.business-dialog,
.business-dialog.el-dialog,
div.business-dialog.el-dialog {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.96) 0%, rgba(30, 41, 59, 0.94) 100%) !important;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px) !important;
  background-size: 20px 20px !important;
  background-position: 0 0, 0 0 !important;
  backdrop-filter: blur(30px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(30px) saturate(180%) !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 16px !important;
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  color: #e5e7eb !important;
}

.el-dialog.business-dialog .el-dialog__header,
.business-dialog.el-dialog .el-dialog__header,
div.business-dialog.el-dialog .el-dialog__header {
  background: transparent !important;
  background-color: transparent !important;
}

.el-dialog.business-dialog .el-dialog__body,
.business-dialog.el-dialog .el-dialog__body,
div.business-dialog.el-dialog .el-dialog__body {
  background: transparent !important;
  background-color: transparent !important;
  color: #e5e7eb !important;
}

/* 遮罩层样式 */
.business-dialog-overlay,
.el-overlay.business-dialog__overlay,
.el-overlay-dialog {
  background-color: rgba(0, 0, 0, 0.75) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* 使用属性选择器进一步覆盖 */
[class*="business-dialog"].el-dialog,
.el-dialog[class*="business-dialog"] {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.96) 0%, rgba(30, 41, 59, 0.94) 100%) !important;
  background-color: rgba(15, 23, 42, 0.96) !important;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px) !important;
  background-size: 20px 20px !important;
  background-position: 0 0, 0 0 !important;
  backdrop-filter: blur(30px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(30px) saturate(180%) !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 16px !important;
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  color: #e5e7eb !important;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #f6f7fb;
  background: radial-gradient(circle at top left, #1f2937 0, #020617 40%, #000 100%);
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 商务合作区域 */
.business-contact {
  margin-top: auto;
  padding: 40px 0;
  background: linear-gradient(180deg, transparent 0%, rgba(15, 23, 42, 0.3) 100%);
  border-top: 1px solid rgba(148, 163, 184, 0.1);
}

.business-contact-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.business-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e5e7eb;
}

.business-title svg {
  width: 24px;
  height: 24px;
  color: rgba(251, 191, 36, 0.9);
}

.business-title h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #f9fafb;
}

.contact-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.contact-label {
  color: rgba(148, 163, 184, 0.8);
  font-weight: 500;
}

.contact-value {
  color: #e5e7eb;
  font-weight: 400;
}

.contact-link {
  color: rgba(96, 165, 250, 0.9);
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #60a5fa;
  text-decoration: underline;
}

.global-footer {
  padding: 20px 0;
  text-align: center;
  background: transparent;
}

.footer-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-text {
  font-size: 12px;
  color: rgba(148, 163, 184, 0.6);
  letter-spacing: 0.5px;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 80px;
  right: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.9));
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(148, 163, 184, 0.4);
  color: #e5e7eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transition: all 0.3s ease;
  box-shadow:
    0 8px 32px rgba(15, 23, 42, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.back-to-top:hover {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(30, 41, 59, 0.95));
  border-color: rgba(251, 191, 36, 0.6);
  color: #facc15;
  transform: translateY(-4px);
  box-shadow:
    0 12px 40px rgba(251, 191, 36, 0.3),
    0 8px 32px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.back-to-top:active {
  transform: translateY(-2px);
}

.back-to-top svg {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.back-to-top:hover svg {
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 60px;
    right: 20px;
    width: 44px;
    height: 44px;
  }

  .back-to-top svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 520px) {
  .back-to-top {
    bottom: 50px;
    right: 16px;
    width: 40px;
    height: 40px;
  }

  .back-to-top svg {
    width: 18px;
    height: 18px;
  }
}

/* 商务合作弹窗样式 - 全局样式覆盖 */
.business-dialog.el-dialog {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.96) 0%, rgba(30, 41, 59, 0.94) 100%) !important;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px) !important;
  background-size: 20px 20px !important;
  background-position: 0 0, 0 0 !important;
  backdrop-filter: blur(30px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(30px) saturate(180%) !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 16px !important;
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  color: #e5e7eb !important;
}

:deep(.business-dialog) {
  background-color: transparent !important;
}

:deep(.business-dialog .el-overlay) {
  background-color: rgba(0, 0, 0, 0.75) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

:deep(.business-dialog .el-overlay-dialog) {
  background-color: transparent !important;
}

:deep(.business-dialog.el-dialog),
:deep(.business-dialog .el-dialog) {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.96) 0%, rgba(30, 41, 59, 0.94) 100%) !important;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px) !important;
  background-size: 20px 20px !important;
  background-position: 0 0, 0 0 !important;
  backdrop-filter: blur(30px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(30px) saturate(180%) !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 16px !important;
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  color: #e5e7eb !important;
}

:deep(.business-dialog .el-dialog__header) {
  background: transparent !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
  padding: 20px 24px !important;
  margin: 0 !important;
}

:deep(.business-dialog .el-dialog__body) {
  background: transparent !important;
  color: #e5e7eb !important;
  padding: 24px !important;
}

:deep(.business-dialog .el-dialog__header) {
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  padding: 20px 24px;
  margin: 0;
  background: transparent;
}

:deep(.business-dialog .el-dialog__headerbtn) {
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.6);
  transition: all 0.3s ease;
}

:deep(.business-dialog .el-dialog__headerbtn:hover) {
  background: rgba(15, 23, 42, 0.8);
}

:deep(.business-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: rgba(148, 163, 184, 0.8);
  font-size: 18px;
  transition: all 0.3s ease;
}

:deep(.business-dialog .el-dialog__headerbtn .el-dialog__close:hover) {
  color: #facc15;
}

:deep(.business-dialog .el-dialog__body) {
  padding: 24px;
  background: transparent;
}

.business-dialog-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 4px;
}

.business-dialog-header-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.15), rgba(245, 158, 11, 0.1));
  border-radius: 12px;
  border: 1px solid rgba(251, 191, 36, 0.25);
  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);
  transition: all 0.3s ease;
}

.business-dialog-header-icon svg {
  width: 22px;
  height: 22px;
  color: rgba(251, 191, 36, 0.95);
}

.business-dialog-header-title {
  font-size: 22px;
  font-weight: 700;
  color: #f9fafb;
  margin: 0;
  letter-spacing: -0.02em;
}

.business-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.business-dialog-desc {
  color: rgba(148, 163, 184, 0.7);
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
  text-align: center;
}

.business-feature-section {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  position: relative;
}

.business-feature-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  padding: 0;
}

.business-feature-icon {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.25), rgba(147, 51, 234, 0.2));
  border: none;
  box-shadow:
    0 8px 32px rgba(59, 130, 246, 0.3),
    0 0 0 1px rgba(96, 165, 250, 0.2);
  flex-shrink: 0;
  position: relative;
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    box-shadow:
      0 8px 32px rgba(59, 130, 246, 0.3),
      0 0 0 1px rgba(96, 165, 250, 0.2);
  }

  50% {
    box-shadow:
      0 8px 40px rgba(59, 130, 246, 0.4),
      0 0 0 2px rgba(96, 165, 250, 0.3);
  }
}

.business-feature-icon svg {
  width: 36px;
  height: 36px;
  color: rgba(96, 165, 250, 1);
  filter: drop-shadow(0 2px 12px rgba(96, 165, 250, 0.5));
}

.business-feature-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.business-feature-title {
  font-size: 26px;
  font-weight: 800;
  color: #f9fafb;
  margin: 0;
  letter-spacing: -0.04em;
  background: linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.3;
}

.business-feature-desc {
  font-size: 15px;
  color: rgba(203, 213, 225, 0.9);
  line-height: 1.75;
  margin: 0;
  font-weight: 400;
  max-width: 460px;
  margin: 0 auto;
  letter-spacing: 0.01em;
}

.contact-section {
  margin-top: 0;
  padding-top: 28px;
  border-top: 1px solid rgba(148, 163, 184, 0.2);
  position: relative;
}

.contact-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.4), transparent);
}

.contact-section-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(203, 213, 225, 0.8);
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.contact-info-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.contact-info-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  background: radial-gradient(circle at top left, rgba(15, 23, 42, 0.96), rgba(15, 23, 42, 0.9));
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.9);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.contact-info-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(96, 165, 250, 0.6), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.contact-info-item:hover {
  border-color: rgba(148, 163, 184, 0.5);
  transform: translateY(-3px);
  box-shadow:
    0 24px 56px rgba(15, 23, 42, 1),
    0 0 0 1px rgba(255, 255, 255, 0.05);
}

.contact-info-item:hover::before {
  opacity: 1;
}

.contact-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
  transition: all 0.3s ease;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(148, 163, 184, 0.3);
}

.contact-icon svg {
  width: 20px;
  height: 20px;
}

.contact-icon--wechat {
  color: rgba(7, 193, 96, 0.9);
}

.contact-icon--phone {
  color: rgba(96, 165, 250, 0.9);
}

.contact-icon--email {
  color: rgba(251, 191, 36, 0.9);
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.contact-label {
  color: #9ca3af;
  font-weight: 400;
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.contact-value {
  color: #f9fafb;
  font-size: 15px;
  font-weight: 600;
}

.contact-link {
  color: rgba(96, 165, 250, 0.9);
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #60a5fa;
  text-decoration: none;
}

.business-dialog-footer {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
  text-align: center;
  position: relative;
}

.business-dialog-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.3), transparent);
}

.business-footer-text {
  font-size: 12px;
  color: rgba(148, 163, 184, 0.65);
  letter-spacing: 0.3px;
  font-weight: 400;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  :deep(.business-dialog .el-overlay-dialog) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .el-dialog.business-dialog,
  .business-dialog.el-dialog,
  div.business-dialog.el-dialog,
  [class*="business-dialog"].el-dialog,
  .el-dialog[class*="business-dialog"] {
    width: 90% !important;
    max-width: 90% !important;
    margin: 0 auto !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
  }

  :deep(.business-dialog .el-dialog__header) {
    padding: 16px 18px !important;
  }

  :deep(.business-dialog .el-dialog__body) {
    padding: 18px !important;
  }

  .business-dialog-header {
    gap: 10px;
  }

  .business-dialog-header-icon {
    width: 32px;
    height: 32px;
  }

  .business-dialog-header-icon svg {
    width: 18px;
    height: 18px;
  }

  .business-dialog-header-title {
    font-size: 18px;
  }

  .business-dialog-content {
    gap: 28px;
  }

  .business-dialog-header-title {
    font-size: 20px;
  }

  .business-feature-section {
    margin: 0 0 24px;
  }

  .business-feature-box {
    gap: 16px;
  }

  .business-feature-icon {
    width: 56px;
    height: 56px;
    border-radius: 18px;
  }

  .business-feature-icon svg {
    width: 28px;
    height: 28px;
  }

  .business-feature-title {
    font-size: 20px;
  }

  .business-feature-desc {
    font-size: 14px;
    max-width: 100%;
  }

  .contact-info-item {
    padding: 14px 16px;
    gap: 12px;
  }

  .contact-icon {
    width: 36px;
    height: 36px;
  }

  .contact-icon svg {
    width: 18px;
    height: 18px;
  }

  .contact-label {
    font-size: 10px;
  }

  .contact-value {
    font-size: 14px;
  }

  .business-dialog-footer {
    margin-top: 20px;
    padding-top: 16px;
  }

  .business-footer-text {
    font-size: 11px;
  }

  :deep(.business-dialog .el-dialog__headerbtn) {
    top: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
  }

  :deep(.business-dialog .el-dialog__headerbtn .el-dialog__close) {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  :deep(.business-dialog .el-overlay-dialog) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .el-dialog.business-dialog,
  .business-dialog.el-dialog,
  div.business-dialog.el-dialog,
  [class*="business-dialog"].el-dialog,
  .el-dialog[class*="business-dialog"] {
    width: 95% !important;
    max-width: 95% !important;
    margin: 0 auto !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
  }

  :deep(.business-dialog .el-dialog__header) {
    padding: 14px 16px !important;
  }

  :deep(.business-dialog .el-dialog__body) {
    padding: 16px !important;
  }

  .contact-info-item {
    padding: 12px 14px;
  }
}
</style>
